
import React from 'react';
import { X, Scale, Megaphone, Bell, CheckCircle, ScrollText } from 'lucide-react';

interface TermsModalProps {
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[150] bg-stone-900/60 backdrop-blur-md flex items-center justify-center p-6 animate-in fade-in duration-300">
      <div 
        className="bg-[#fcfbf7] w-full max-w-2xl max-h-[85vh] rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col animate-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-8 border-b border-stone-200 flex justify-between items-center bg-white">
          <div className="flex items-center gap-3">
            <div className="bg-amber-100 p-2 rounded-lg text-amber-700">
              <ScrollText size={20} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-stone-900 uppercase tracking-tighter">Términos y Condiciones</h2>
              <p className="text-[10px] text-stone-400 font-bold uppercase tracking-widest">Uso de Plataforma • Arte-Sano</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-stone-100 rounded-full transition-colors text-stone-400 hover:text-stone-900"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-grow overflow-y-auto p-10 space-y-8 text-stone-600 leading-relaxed font-light">
          <section className="bg-amber-50/50 p-6 rounded-2xl border border-amber-100">
            <div className="flex items-center gap-2 mb-3 text-amber-900 font-bold uppercase text-xs tracking-widest">
              <Megaphone size={14} className="text-amber-600" />
              <span>Autorización de Publicidad</span>
            </div>
            <p className="text-sm font-medium text-stone-800">
              Al proporcionar su dirección de correo electrónico en nuestra plataforma, usted otorga su <span className="underline decoration-amber-400 underline-offset-2">consentimiento expreso, previo e informado</span> a Arte-Sano para recolectar, almacenar y utilizar sus datos con el fin de enviarle información publicitaria, promocional y novedades comerciales.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <Scale size={14} className="text-stone-400" />
              <span>1. Alcance de la Información</span>
            </div>
            <p className="text-sm">
              La información enviada puede incluir catálogos digitales, lanzamientos de productos de temporada, beneficios por fidelidad y noticias relacionadas con la cultura panadera de Arte-Sano.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <Bell size={14} className="text-stone-400" />
              <span>2. Frecuencia de Comunicaciones</span>
            </div>
            <p className="text-sm">
              Nos comprometemos a una comunicación respetuosa. El envío de información publicitaria no será invasivo y usted podrá gestionar la frecuencia o darse de baja en cualquier momento.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3 text-stone-900 font-bold uppercase text-xs tracking-widest">
              <CheckCircle size={14} className="text-stone-400" />
              <span>3. Exactitud de Datos</span>
            </div>
            <p className="text-sm">
              El suscriptor garantiza que el correo proporcionado es de su propiedad y está habilitado para recibir comunicaciones externas. Arte-Sano no se hace responsable por errores en la recepción debido a datos incorrectos proporcionados por el usuario.
            </p>
          </section>

          <div className="pt-8 border-t border-stone-100">
            <p className="text-[10px] italic text-stone-400 text-center uppercase tracking-widest">
              Al hacer clic en "Suscribirse", usted acepta estos términos de manera íntegra.
            </p>
          </div>
        </div>

        {/* Footer Action */}
        <div className="p-6 bg-stone-50 border-t border-stone-200 flex justify-center">
          <button 
            onClick={onClose}
            className="bg-stone-900 text-white px-10 py-3 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-stone-700 transition-all shadow-md active:scale-95"
          >
            Aceptar Términos
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
